module.exports = __webpack_public_path__ + "static/img/2.bd4540c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/eng/2.png
// module id = E47v
// module chunks = 0